import { render, staticRenderFns } from "./EditOnCallPopup.vue?vue&type=template&id=28bd9b5e&"
import script from "./EditOnCallPopup.vue?vue&type=script&lang=js&"
export * from "./EditOnCallPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports